<ul>
  @for (popupMessage of popupCenterService.messageList(); track popupMessage.id) {
    <li [class]="popupMessage.type" animate.enter="popup-enter" animate.leave="popup-leave">
      <div>
        @switch (popupMessage.type) {
          @case ('info') {
            <svg-icon icon="icon_approved" />
          }
          @case ('error') {
            <svg-icon icon="icon_attention" />
          }
          @case ('warning') {
            <svg-icon icon="icon_warning" />
          }
        }
        <div>
          <strong [innerText]="popupMessage.title"></strong>
          @if (popupMessage.message; as messageText) {
            <p [innerText]="messageText"></p>
          }
          @if (popupMessage.action; as popupAction) {
            <dmb-button
              type="button"
              variant="secondary"
              (buttonClick)="popupCenterService.triggerAction(popupMessage.id)"
              >{{ popupAction.buttonText }}</dmb-button
            >
          }
        </div>
        <button matIconButton (click)="popupCenterService.closePopup(popupMessage.id)">
          <svg-icon icon="icon_cancel" />
        </button>
      </div>
    </li>
  }
</ul>
